// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nSdxn","image":"Header_image__1yeMC","name":"Header_name__38xh5","info":"Header_info__NCBT5","infoRow":"Header_infoRow__m0wkp"};